import { render, staticRenderFns } from "./SynonymsReadingEnForm.vue?vue&type=template&id=71c3876b&scoped=true&lang=pug&"
import script from "./SynonymsReadingEnForm.vue?vue&type=script&lang=js&"
export * from "./SynonymsReadingEnForm.vue?vue&type=script&lang=js&"
import style0 from "./SynonymsReadingEnForm.vue?vue&type=style&index=0&id=71c3876b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3876b",
  null
  
)

export default component.exports